// extracted by mini-css-extract-plugin
export default {"body":"proyeccion-ap_body__UGpJh"};